var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cookie-law',{attrs:{"theme":"dark-lime--rounded","button-decline":true,"button-text":"Accept"}},[_c('div',{attrs:{"slot":"message"},slot:"message"},[_vm._v(" This site uses cookies to help you get the best experience. To find out more read "),_c('a',{attrs:{"href":_vm.$t('privacyUrl')}},[_vm._v("our privacy policy")]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }